import clsx from 'clsx';
import React from 'react';
import { Shimmer } from '~/shared/components';
import styles from './ProductRecommendations.module.scss';
import skeleton from './ProductRecommendationsSkeleton.module.scss';

type ProductRecommendationsSkeletonProps = {
    /** How many cards to stand in for. The page knows this before the products arrive. */
    count: number;
};

export const ProductRecommendationsSkeleton: React.FC<ProductRecommendationsSkeletonProps> = ({
    count,
}) => (
    <ul className={styles.recommendationsList}>
        {Array.from({ length: count }, (_, index) => (
            <li key={index} className={clsx(styles.recommendationsItem, skeleton.item)}>
                <div className={styles.recommendation}>
                    <div className={styles.recommendationImage}>
                        <Shimmer className={skeleton.image} />
                    </div>

                    <div className={styles.recommendationOverview}>
                        <div className={styles.recommendationDetails}>
                            <Shimmer className={clsx(skeleton.line, skeleton.brand)} />
                            <Shimmer className={clsx(skeleton.line, skeleton.name)} />

                            <div className={skeleton.priceList}>
                                <Shimmer className={clsx(skeleton.line, skeleton.price)} />
                            </div>
                        </div>

                        <div className={styles.recommendationActions}>
                            <Shimmer className={skeleton.button} />
                        </div>
                    </div>
                </div>
            </li>
        ))}
    </ul>
);
